module.exports = __webpack_public_path__ + "img/se.d0fe78d6.svg";